import React from 'react';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import { FORM_MODES } from 'config/formModes';
import styles from './toolbarToggle.module.scss';

const classNameBuilder = classnames.bind(styles);

export const ToolbarToggle = ({
    onLeftChildClick,
    leftChild,
    onRightChildClick,
    rightChild,
    isLeftToggleSelected,
    dataAutomationKey,
    rightToggleButtonClassName,
    leftToggleButtonClassName,
    disabled = false,
    mode = FORM_MODES.CREATE,
    containerClassName,
    leftToggleOverride,
    rightToggleOverride,
}) => {
    const containerClass = containerClassName || classNameBuilder('container');
    const leftButtonClassName =
        leftToggleOverride ||
        classNameBuilder(
            'toggle-button',
            'left',
            {
                selected: isLeftToggleSelected,
                editMode: mode === FORM_MODES.EDIT,
            },
            leftToggleButtonClassName
        );

    const rightButtonClassName =
        rightToggleOverride ||
        classNameBuilder(
            'toggle-button',
            'right',
            {
                selected: !isLeftToggleSelected,
                editMode: mode === FORM_MODES.EDIT,
            },
            rightToggleButtonClassName
        );

    return (
        <div className={containerClass} data-automation={dataAutomationKey}>
            <div className={leftButtonClassName} onClick={!disabled ? onLeftChildClick : null}>
                {leftChild}
            </div>
            <div className={rightButtonClassName} onClick={!disabled ? onRightChildClick : null}>
                {rightChild}
            </div>
        </div>
    );
};

ToolbarToggle.propTypes = {
    onLeftChildClick: PropTypes.func,
    leftChild: PropTypes.node,
    onRightChildClick: PropTypes.func,
    rightChild: PropTypes.node,
    isLeftToggleSelected: PropTypes.bool,
    dataAutomationKey: PropTypes.string,
};
